import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getSetCookie from './../../../cookie';
import { provideHooks } from 'redial';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import Header from '../Header/Header';
import { renderRoutes } from 'react-router-config';
import { cleanReturnExchange } from '../../../actionCreators/returnExchange';
import Footer from '../../components/Footer/Footer';
import Shortlist from '../../components/Common/Shortlist';
import ToastMessage from '../../../mobile/components/ToastMessage/ToastMessage';
import * as headerCallsActionCreators from './../../../actionCreators/header';
import * as commonCallsActionCreators from './../../../actionCreators/common';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import * as homeCallsActionCreators from './../../../actionCreators/home';
import * as checkoutCallsActionCreators from '../../../actionCreators/checkout';
import { getLocaleData } from '../../../actionCreators/locale';
import { getCart } from '../../../actionCreators/cart';
import { getYotpoSiteRatings } from '../../../actionCreators/yotpo';
import ExchangeSessionDesktop from '../../../desktop/components/MyAccount/exchangeSessionDesktop';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';

import {
  appendScriptToDOM,
  isSearchCrawler,
  isEmptyObject,
  getUserEventData,
  setGAEventListener,
  initChatBot,
  initSprinklrChatBot,
  updateChatBotParams,
} from '../../../utils/helper';
import config from 'config';
// import cartPixel from './../../../addCartPixel';
import 'custom-event-polyfill';
import './App.scss';
import AppHelmet from '../../../CommonComponents/Helmet/AppHelmet';
import CrossCountryStrip from '../../../CommonComponents/CrossCountryStrip/CrossCountryStrip';
import { langCodeAllowed } from '../../../locales';
import { setCountryData } from '../../../helpers/countryConfig';
let countryCode = process.env.COUNTRY;

@provideHooks({
  fetch: async ({ location, reqHeaders, store: { dispatch, getState } }) => {
    if (__SERVER__) {
      countryCode = langCodeAllowed[countryCode.toLowerCase()] ? countryCode.toLowerCase() : 'in';
      dispatch(commonCallsActionCreators.localeInfo(langCodeAllowed[countryCode]));
      setCountryData(langCodeAllowed[countryCode]);
    }
    const state = getState();
    // get locale config data
    if (isEmptyObject(state.locale)) {
      dispatch(getLocaleData());
    }
    if (state.common.wishlistTrue === true) {
      dispatch(commonCallsActionCreators.showWishlist(false));
    }
    if (
      (location.pathname && location.pathname?.indexOf('/checkout/onepage') !== -1) ||
      location.pathname?.indexOf('presales') !== -1 ||
      location.pathname?.indexOf('/sales/order') > -1 ||
      location.pathname?.indexOf('/checkout/payment/qr') !== -1 ||
      location.pathname?.indexOf('/checkout/payment/collect') !== -1 ||
      location.pathname.toLowerCase()?.indexOf('/hto') !== -1 ||
      location.pathname?.indexOf('/checkout/payment/confirm') !== -1 ||
      location.pathname.includes('lens-package-upgrade')
      // ||
      // location.pathname.toLowerCase()?.indexOf('/cart') !== -1
    ) {
      dispatch(showGlobalHeaderFooter({ header: false, footer: false }));
      if (__SERVER__) {
        await dispatch(commonCallsActionCreators.validateSession(location.pathname));
      }
    } else {
      dispatch(showGlobalHeaderFooter({ header: true, footer: true }));
    }
    if (__CLIENT__) {
      if (state.common.login !== Boolean(parseInt(getSetCookie.getCookie('isLogined'), 10))) {
        dispatch(commonCallsActionCreators.getUserInfo());
      }
    }
    const mainNavigationData = state.header.mainNavigationData;
    const redisCommonData = state.common.redisCommonData;
    if (__SERVER__) {
      const uA = reqHeaders['user-agent'];
      const isBot = uA ? isSearchCrawler(uA) : false;
      if (!mainNavigationData || isEmptyObject(mainNavigationData)) {
        await dispatch(headerCallsActionCreators.getMainNav());
      }
      // await dispatch(headerCallsActionCreators.getTopNavDataFromLocal());
      if (!redisCommonData || isEmptyObject(redisCommonData)) {
        await dispatch(commonCallsActionCreators.getRedisData(isBot));
      }
    }
    if (
      location.pathname &&
      (location.pathname?.indexOf('/reviews') !== -1 ||
        location.pathname?.indexOf('/shop-instagram') !== -1 ||
        location.pathname?.indexOf('/support') !== -1 ||
        location.pathname?.indexOf('/frame-size') !== -1)
    ) {
      dispatch(commonCallsActionCreators.changeLogo('lenskart'));
    }
  },
  defer: ({ store: { dispatch, getState } }) => {
    const state = getState();
    const { countryData, localeInfo } = state.common;
    const countryCodeCookie = getSetCookie.getCookie('countryCode');
    const trafficSource = getSetCookie.getCookie('trafficSource');
    countryCode =
      countryCodeCookie && langCodeAllowed.hasOwnProperty(countryCodeCookie.toLowerCase())
        ? countryCodeCookie.toLowerCase()
        : 'in';

    const { showGlobalHeader } = state.header;
    if (!localeInfo) {
      dispatch(commonCallsActionCreators.localeInfo(langCodeAllowed[countryCode]));
    }
    setCountryData(langCodeAllowed[countryCode]);
    // get locale config data
    if (isEmptyObject(state.locale)) {
      dispatch(getLocaleData());
    }
    if (
      countryCodeCookie &&
      trafficSource &&
      countryCodeCookie.toLowerCase() !== trafficSource.toLowerCase() &&
      trafficSource.toLowerCase() !== 'in' &&
      !countryData &&
      showGlobalHeader
    ) {
      dispatch(commonCallsActionCreators.getCountryData(trafficSource));
    }
    if (__SERVER__) {
      dispatch(getYotpoSiteRatings());
    }
  },
})
class App extends Component {
  static propTypes = {
    commonCallsActionCreators: PropTypes.any.isRequired,
    headerCallsActionCreators: PropTypes.any.isRequired,
    homeCallsActionCreators: PropTypes.any.isRequired,
    redisCommonData: PropTypes.any,
    mainNavigationData: PropTypes.any,
    isMenuVisible: PropTypes.bool,
    showGlobalHeader: PropTypes.bool,
    loginStatus: PropTypes.bool,
    wishlistTrue: PropTypes.bool,
    route: PropTypes.objectOf(PropTypes.any).isRequired,
    showWishlist: PropTypes.func,
    isWishlistCount: PropTypes.number,
    isCartCount: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.checkId = this.checkId.bind(this);
    this.state = {
      notExchangeSession: false,
    };
  }
  componentDidMount() {
    setGAEventListener();
    const {
      commonCallsActionCreators,
      loginStatus,
      homeCallsActionCreators,
      location,
      redisCommonData,
      localeInfo,
    } = this.props;
    const exchangeMethod = getSetCookie.getCookie('exchangeMethod');
    const sprinklrBotEnabled =
      redisCommonData?.SPRINKLR_BOT_CONFIG &&
      JSON.parse(redisCommonData?.SPRINKLR_BOT_CONFIG)?.desktop_enabled === 'ON';
    const returnAction =
      sessionStorageHelper.getItem('returnAction') ||
      sessionStorageHelper.getItem('returnProduct')?.returnAction;
    const returnMode = sessionStorageHelper.getItem('returnProduct')?.returnMode === 'store_return';
    const isExchangeSessionValid = returnAction || returnMode;
    if (exchangeMethod && !isExchangeSessionValid) {
      (() => {
        this.setState({ notExchangeSession: true });
      })();
    }
    // const { trackjs_token, trackjs_application } = localeInfo;
    const { facebookPixel } = localeInfo;
    let path =
      location && location.pathname.length > 1
        ? location.pathname.slice(1).replace(/(\/+)$/g, '')
        : '/';
    path = path !== '' ? path : '/';
    setTimeout(() => {
      if (
        [
          'eyeglasses.html',
          'sunglasses.html',
          'premium-eyeglasses',
          'premium-sunglasses',
          '/',
        ].includes(path) ||
        path?.indexOf('promo/') > -1
      ) {
        homeCallsActionCreators.loadCarousalsData();
      }
    }, 50);
    this.loadThirdPartyLibraries(sprinklrBotEnabled);
    window.ReactPixel = require('react-facebook-pixel');
    const { init, pageView } = window.ReactPixel.default;
    init(facebookPixel);
    pageView();
    // if (getSetCookie.getCookie('clientV1') === '') {
    //   commonCallsActionCreators.setJunoSession();
    // }
    if (!getSetCookie.getCookie('session')) {
      getSetCookie.setCookie('session', 'sticky', 14);
    }
    if (
      !loginStatus &&
      (getSetCookie.getCookie('clientV1') || getSetCookie.getCookie(`clientV1_${countryCode}`))
    ) {
      if (!getSetCookie.getCookie(`clientV1_${countryCode}`)) {
        const cookieVal = getSetCookie.getCookie('clientV1');
        getSetCookie.deleteCookie('clientV1');
        getSetCookie.setCookie(`clientV1_${countryCode}`, cookieVal, 30);
      }
      let i = 0;
      while (getSetCookie.getCookie('clientV1') && i < 5) {
        getSetCookie.deleteCookie('clientV1');
        i++;
      }
      setTimeout(() => {
        commonCallsActionCreators.validateSession(location.pathname);
      }, 500);
    }
    // headerCallsActionCreators.getMainNav();
    if (window.dtm === undefined) {
      window.dtm = {};
      window.dtm.pageName = 'baseAbort';
    }
    if (window.dtm) {
      window.dtm.site = 'webDesktop';
      window.dtm.sessionID = getSetCookie.getCookie('omniSession');
      window.dtm.loginStatus = loginStatus ? 'registered' : 'guest';
    }
    window.localStorage.removeItem('showEnterAddress');
    // desktopGTM event for omni and gtm
    if (typeof window.desktopGTM === 'undefined') {
      window.desktopGTM = document.createEvent('Event');
      window.desktopGTM.initEvent('desktopGTM', true, true);
      window.setTimeout(() => {
        window.dispatchEvent(window.desktopGTM);
        if (
          typeof window.FMApi === 'object' &&
          typeof window.FMApi.manualTriggerExperiment === 'function'
        ) {
          window.FMApi = window.FMApi || [];
          window.FMApi.push('fm_activate_adobe_integration');
        }
      }, 800);
    }

    setTimeout(() => {
      if (process.env.BUILD_ENV === 'production') {
        // TrackJs Call
        // const db = indexedDB.open('test');
        // db.onsuccess = () => {
        //   appendScriptToDOM(
        //     'https://cdn.trackjs.com/agent/v3/latest/t.js',
        //     'trackjs',
        //     true,
        //     () => {
        //       window.TrackJS.install({
        //         token: trackjs_token,
        //         application: trackjs_application,
        //         enabled: !(window.location.host?.indexOf('localhost') >= 0 || window.location.host?.indexOf('lenskart.com:8081') >= 0)
        //       });
        //     }
        //   );
        // };
        // Live Chat Js Call
        // ---------- removed because license has been expired ---------------
        // if (sessionStorage.getItem('session') !== 'doctor') {
        //   window.__lc = window.__lc || {};
        //   window.__lc.license = 1195391;
        //   (() => {
        //     const lc = document.createElement('script');
        //     lc.type = 'text/javascript';
        //     lc.async = true;
        //     lc.src = `${
        //       document.location.protocol === 'https:' ? 'https://' : 'http://'
        //     }cdn.livechatinc.com/tracking.js`;
        //     const st = document.getElementsByTagName('script')[0];
        //     st.parentNode.insertBefore(lc, st);
        //   })();
        // }
      }
    }, 3000);
    commonCallsActionCreators.getAudienceType();
    if (redisCommonData?.ENABLE_FRESHWORKS_DESKTOP === 'OFF') {
      setTimeout(() => {
        const freshwidget = document.getElementById('freshworks-container');
        if (freshwidget) {
          freshwidget.style.display = 'none';
        }
      }, 0);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      loginStatus,
      userInfo,
      isValidSession,
      commonCallsActionCreators,
      addToCartFailed,
      location,
    } = this.props;
    if (prevProps.isValidSession !== isValidSession && isValidSession === 401) {
      commonCallsActionCreators.setJunoSession();
    }
    // if new arch cookie not present then delete cameFromNewArch cookie as well
    if (!getSetCookie.getCookie('newArch')) getSetCookie.deleteCookie('cameFromNewArch');
    /* 
      if cameFromNewArch cookie is present and isReturnExOld cookie is not present
      and the path of the url does not have / sales / or / customer / then do a hard refresh
    */
    if (
      getSetCookie.getCookie('cameFromNewArch') &&
      !getSetCookie.getCookie('isReturnExOld') &&
      !(
        location.pathname.includes('/sales/') ||
        location.pathname.includes('/customer/') ||
        location.pathname.includes('/editpower/options/view')
      )
    ) {
      console.log('Route Change Detected');
      window.location.reload(true);
    }
    if (getSetCookie.getCookie('clientV1') && !getSetCookie.getCookie(`clientV1_${countryCode}`)) {
      const cookieVal = getSetCookie.getCookie('clientV1');
      // getSetCookie.deleteCookie('clientV1');
      getSetCookie.setCookie(`clientV1_${countryCode}`, cookieVal, 30);
      let i = 0;
      while (getSetCookie.getCookie('clientV1') && i < 5) {
        getSetCookie.deleteCookie('clientV1');
        i++;
      }
    }
    if (
      !prevProps.isWishlistCount &&
      this.props.isWishlistCount &&
      getSetCookie.getCookie(`clientV1_${countryCode}`) !== '' &&
      this.props.location.pathname &&
      this.props.location.pathname?.indexOf('/checkout/onepage/') === -1
    ) {
      // const cookieVal = getSetCookie.getCookie(`clientV1_${countryCode}`);
      // getSetCookie.deleteCookie(`clientV1_${countryCode}`);
      // getSetCookie.setCookie(`clientV1_${countryCode}`, cookieVal, 30)
      // const { commonCallsActionCreators } = this.props;
      commonCallsActionCreators.shortlist('', 'get', '?attributes=true');
      // if (wishlistTrue) commonCallsActionCreators.showWishlist(false);
    }
    // passingUtmData
    if (
      userInfo &&
      prevProps.userInfo !== userInfo &&
      prevProps.userInfo?.result?.id !== userInfo?.result?.id &&
      loginStatus
    ) {
      // shipping address component for exchange
      const exchangeFlow = sessionStorageHelper.getItem('exchangeFlow');
      const returnProductDetails = sessionStorageHelper.getItem('returnProduct') || {};
      const { returnAction } = returnProductDetails;
      if (!(exchangeFlow && returnAction === 'exchange')) {
        this.props.getCart();
      }
      // shipping address component for exchange

      const { phoneCode, telephone } = userInfo?.result;
      if (location.pathname?.indexOf('/checkout') > -1) {
        this.passingUtmData('ADD_TO_CART_LOGIN', phoneCode, telephone);
      }
      if (location.pathname === '/') {
        this.passingUtmData('LOGGED_IN', phoneCode, telephone);
      }
    }

    // update DTM login status
    if (loginStatus && userInfo) {
      const {
        result: { phoneCode, telephone, lastName, firstName, gender },
      } = userInfo;
      window.dtm.loginStatus = 'registered';
      window.dtm.customerID = userInfo && userInfo.result.id;
      const gaData = {
        Name: `${firstName} ${lastName}`,
        Identity: telephone,
        Phone: `${phoneCode}${telephone}`,
      };
      if (gender && gender.toLowerCase()?.indexOf('male') > -1) {
        const genderType = gender.toLowerCase();
        gaData.Gender = genderType === 'male' ? 'M' : 'F';
      }
      if (
        typeof window.clevertap !== 'undefined' &&
        userInfo &&
        loginStatus !== prevProps.loginStatus
      ) {
        window.clevertap.onUserLogin.push({
          Site: gaData,
        });
        window.clevertap.event.push('Sign In', {
          pageName: 'loggedIn Successfull from desktop',
        });
      }
    } else {
      window.dtm.loginStatus = 'guest';
      delete window.dtm.customerID;
    }

    // trigger update if user logs in - or logged in(script loaded initially)
    const sprinklrBotEnabled =
      this.props.redisCommonData?.SPRINKLR_BOT_CONFIG &&
      JSON.parse(this.props.redisCommonData?.SPRINKLR_BOT_CONFIG)?.desktop_enabled;
    if (
      sprinklrBotEnabled === 'ON' &&
      window?.sprChat &&
      userInfo &&
      userInfo.result.login &&
      prevProps.userInfo !== userInfo
    ) {
      updateChatBotParams(userInfo.result, this.props.platform, this.props.redisCommonData);
    }

    if (
      prevProps.addToCartFailed === null &&
      addToCartFailed !== null &&
      addToCartFailed.status === 422 &&
      location.pathname !== '/HTO'
    ) {
      if (addToCartFailed.message?.indexOf('out of stock') !== -1) {
        alert('This product is Out of Stock !');
      } else {
        alert(addToCartFailed.message);
      }
      if (location.pathname === '/cart') return;
      return window.location.reload();
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.sessionStorage.setItem('previousChannel', window.dtm.channel);
    }

    // if (prevProps.cartData !== cartData) {
    //   cartPixel.fireFbq(cartData.result.items, 'AddToCart');
    // }
    const freshBotHide = document
      .getElementById('mobile-chat-container')
      ?.className?.includes('joe-hide');
    if (location.pathname?.indexOf('/support') === -1 && window.Freshbots && !freshBotHide) {
      window.Freshbots.hideWidget(true);
    }
  }

  passingUtmData(eventName, phoneCode, telephone) {
    const { commonCallsActionCreators } = this.props;
    const data = getUserEventData(eventName);
    if (phoneCode && telephone) {
      data.mobileNumber = `${phoneCode}${telephone}`;
    }
    commonCallsActionCreators.passUtmData(data);
  }

  loadThirdPartyLibraries = sprinklrBotEnabled => {
    const { redisCommonData } = this.props;
    if (sprinklrBotEnabled) {
      initSprinklrChatBot({}, false, true, redisCommonData);
    } else {
      initChatBot();
    }
    const freshmarketerEnabled =
      redisCommonData && redisCommonData.ENABLE_FRESHWORKS_DESKTOP === 'ON';
    window.UnbxdSiteName = 'lenskart_com-u1418736834941';

    appendScriptToDOM(
      `https://staticw2.yotpo.com/${config.yotpoConfig.apiKey}/widget.js`,
      'yotpo_widget_lk',
      true,
      null
    );
    appendScriptToDOM(
      'https://d21gpk1vhmjuf5.cloudfront.net/unbxdAnalytics.js',
      'vendor_unbxd',
      true,
      null
    );
    if (freshmarketerEnabled) {
      appendScriptToDOM(
        'https://static.lenskart.com/media/desktop/js/jquery-3.5.1.slim.min.js',
        '',
        false,
        null
      );
      appendScriptToDOM(
        'https://cdn.freshmarketer.com/232805/806426.js',
        'vendor_freshmarketer',
        true,
        null
      );
    }
  };

  checkId() {
    if (this.props.shortListData.result.productList !== null) {
      this.props.shortListData.result.productList.forEach(value => {
        if (this.props.productPageId === value.id) {
          this.props.toggleWishlist(true);
        }
      });
    } else if (this.props.shortListData.result.productList.length === 0) {
      this.props.toggleWishlist(false);
    }
  }

  render() {
    const {
      mainNavigationData,
      section,
      loginStatus,
      route,
      isFilterEnable,
      showGlobalHeader,
      showGlobalFooter,
      location,
      countryData,
      dataLocale,
      cleanReturnExchange,
      localeInfo,
      utmMapping,
      redisCommonData,
    } = this.props;
    const { notExchangeSession } = this.state;
    const trafficSource = getSetCookie.getCookie('trafficSource');
    return (
      <React.Fragment>
        <AppHelmet
          localeInfo={localeInfo}
          location={location}
          pathname={location.pathname}
          redisCommonData={redisCommonData}
          section={section}
        ></AppHelmet>
        {Boolean(showGlobalHeader && countryData && !isSearchCrawler()) &&
          !(
            trafficSource &&
            localeInfo?.allowedTrafficSourceCountries?.includes(trafficSource.toUpperCase())
          ) && (
            <CrossCountryStrip
              countryData={countryData}
              dataLocale={dataLocale}
              localeInfo={localeInfo}
              utmMapping={utmMapping}
            />
          )}
        <div className={isFilterEnable ? 'vertical-filter' : ''}>
          {notExchangeSession && (
            <ExchangeSessionDesktop
              cleanReturnExchange={cleanReturnExchange}
              dataLocale={dataLocale}
            />
          )}
          {/* redisLoading ? <div style={{ zIndex: '99999', left: '0', width: '100%', position: 'fixed', top: '0' }}><Pace height={4} color="orange" /></div> : null */}
          {showGlobalHeader && <Header {...this.props} />}
          <ToastMessage />
          {/* routes setup */}
          {renderRoutes(route.routes)}
          {showGlobalFooter && (
            <Footer
              location={location}
              loginStatus={loginStatus}
              mainNavigationData={mainNavigationData}
              section={section}
            />
          )}
          <Shortlist checkId={this.checkId} {...this.props} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  redisCommonData: state.common.redisCommonData,
  utmMapping: state.common.utmMapping,
  loginStatus: state.common.login,
  wishlistTrue: state.common.wishlistTrue,
  mainNavigationData: state.header.mainNavigationData,
  showGlobalHeader: state.header.showGlobalHeader,
  showGlobalFooter: state.header.showGlobalFooter,
  isMenuVisible: state.header.isMenuVisible,
  userInfo: state.common.userInfo,
  loginLoader: state.common.loginLoader,
  shortListData: state.common.shortListData,
  cartData: state.cart.cartData,
  redisLoading: state.common.redisLoading,
  countryData: state.common.countryData,
  isFilterEnable: state.category.isFilterEnable,
  router: state.router,
  isWishlistCount: state.common.isWishlistCount,
  isCartCount: state.common.isCartCount,
  isSupported: state.common.isSupported,
  checkBrowser: state.common.checkBrowser,
  section: state.common.section,
  isValidSession: state.common.errorCode,
  addToCartFailed: state.cart.addToCartFailed,
  categoryData: state.category.categoryData,
  productData: state.product.productData,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
  platform: state.DTM.platform,
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsActionCreators: bindActionCreators(commonCallsActionCreators, dispatch),
    headerCallsActionCreators: bindActionCreators(headerCallsActionCreators, dispatch),
    checkoutCallsActionCreators: bindActionCreators(checkoutCallsActionCreators, dispatch),
    homeCallsActionCreators: bindActionCreators(homeCallsActionCreators, dispatch),
    getCart: data => dispatch(getCart(data)),
    cleanReturnExchange: () => dispatch(cleanReturnExchange()),
  };
}

App.defaultProps = {
  redisCommonData: {},
  loginStatus: false,
  wishlistTrue: false,
  mainNavigationData: {},
  showGlobalHeader: true,
  isMenuVisible: true,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
